// extracted by mini-css-extract-plugin
module.exports = {"paper":"a4-1of1-qr-20x20_paper__HTuQ9","page":"a4-1of1-qr-20x20_page__2e1qj","container_qr_code":"a4-1of1-qr-20x20_container_qr_code__2Fwhm"};